import { Page, PageIcon } from "entities/pages/types";
import { QueryDocumentSnapshot } from "firebase/firestore";
import { DocumentData, DocumentSnapshot, Timestamp } from "shared/api/firebase";
import { Translations } from "shared/types/languages";

type PageDBT = {
  id: string;
  title: string;
  translations?: Translations;
  modulesCount: number;
  updatedAt: Timestamp;
  isActive: boolean;
  order: number;
  path: string;
  isDefaultForUnauthenticated: boolean;
  isDefaultForAuthenticated: boolean;
  showInBurgerMenu: boolean;
  showInDesktopHeaderMenu: boolean;
  showInMobileBurgerMenuQuickLinks: boolean;
  hasSearch: boolean;
  isMaintenanceMode?: boolean;
  maintenanceModeDescription?: string;
  icon?: PageIcon | null;
};

type PageDataT = Omit<PageDBT, "id">;

export class PageDB {
  id: string;
  title: string;
  translations?: Translations;
  modulesCount: number;
  updatedAt: Timestamp;
  isActive: boolean;
  order: number;
  path: string;
  isDefaultForAuthenticated: boolean;
  isDefaultForUnauthenticated: boolean;
  showInBurgerMenu: boolean;
  showInDesktopHeaderMenu: boolean;
  showInMobileBurgerMenuQuickLinks: boolean;
  hasSearch: boolean;
  isMaintenanceMode?: boolean;
  maintenanceModeDescription?: string;
  icon?: PageIcon | null;

  constructor(page: QueryDocumentSnapshot | DocumentSnapshot<DocumentData>) {
    if (!page.exists()) {
      throw new Error(`Page ${page.id} does not exist`);
    }

    const data = page.data() as PageDataT;

    this.id = page.id;
    this.title = data.title;
    this.translations = data.translations;
    this.modulesCount = data.modulesCount;
    this.updatedAt = data.updatedAt;
    this.isActive = data.isActive;
    this.order = data.order;
    this.path = data.path;
    this.isDefaultForUnauthenticated = data.isDefaultForUnauthenticated;
    this.isDefaultForAuthenticated = data.isDefaultForAuthenticated;
    this.showInBurgerMenu = data.showInBurgerMenu;
    this.showInDesktopHeaderMenu = data.showInDesktopHeaderMenu;
    this.showInMobileBurgerMenuQuickLinks =
      data.showInMobileBurgerMenuQuickLinks;
    this.hasSearch = data.hasSearch;
    this.isMaintenanceMode = data.isMaintenanceMode;
    this.maintenanceModeDescription = data.maintenanceModeDescription;
    this.icon = data.icon;
  }

  toPage(): Page {
    return {
      id: this.id,
      title: this.title,
      translations: this.translations,
      modulesCount: this.modulesCount || 0,
      updatedAt: this.updatedAt.toDate(),
      isActive: this.isActive,
      order: this.order,
      path: this.path,
      isDefaultForUnauthenticated: this.isDefaultForUnauthenticated,
      isDefaultForAuthenticated: this.isDefaultForAuthenticated,
      showInBurgerMenu: this.showInBurgerMenu,
      showInDesktopHeaderMenu: this.showInDesktopHeaderMenu,
      showInMobileBurgerMenuQuickLinks: this.showInMobileBurgerMenuQuickLinks,
      hasSearch: this.hasSearch,
      isMaintenanceMode: this.isMaintenanceMode ?? false,
      maintenanceModeDescription: this.maintenanceModeDescription,
      icon: this.icon ?? null,
    };
  }
}
